import React from "react";
import { Navigate } from "react-router-dom";
import checkPermissions from "../services/permissions";
// Your existing function

const ProtectedInnerRoute = ({ element: Element, requiredRoles = [], ...rest }:any) => {
 // Replace with your token retrieval logic
  const hasPermission = checkPermissions( requiredRoles);

  if (!hasPermission) {
    return <Navigate to="/" />; // Redirect to an unauthorized page
  }

  return <Element {...rest} />;
};

export default ProtectedInnerRoute;
